var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-modal',{attrs:{"customShowDialog":_vm.showImportModal,"dialog-max-width":"70vw","title":_vm.$t('modal.addToCanvas.title'),"hasMainBtn":false},on:{"close":_vm.handleClose,"confirmed":function($event){return _vm.$emit('confirm')}}},[_c('div',{staticStyle:{"font-size":"16px"},attrs:{"slot":"body"},slot:"body"},[_c('display-files',{attrs:{"queries":_vm.queries,"hasActionColumn":false},on:{"confirm":function (id) { return _vm.$emit('confirm', id); },"queryToDeleteId":function (q) { return this$1.queryToDelete = q; }}})],1)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f18a2b8","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mainMenu/AddToCanvasModal.vue
// module id = null
// module chunks = 